import CryptoJS from 'crypto-js';

export function base64(text) {
  const wordArray = CryptoJS.enc.Utf8.parse(text);
  const base64 = CryptoJS.enc.Base64.stringify(wordArray);

  return base64;
}
